import { createRouter, createWebHistory } from 'vue-router';

// NAVBAR / PAGES PUBLIQUES
import Home from './views/navbar/Home.vue';
import Certification from './views/navbar/Certification.vue';
import Produits from './views/navbar/Produits.vue';
import Services from './views/navbar/Services.vue';
import Marques from './views/navbar/Marques.vue';
import References from './views/navbar/References.vue';
import Contact from './views/navbar/Contact.vue';
import Panier from './views/navbar/Panier.vue';
import Shop from './views/navbar/Shop.vue';

// PRODUITS
import Reactifs from './views/product/reactive/Reactifs.vue';
import VitaminesMineraux from './views/product/vitamins/Vitamines-mineraux.vue';
import Topstar from './views/product/Topstar.vue';
import EquipementLabo from './views/product/equipment/EquipementLabo.vue';
import Fort from './views/product/reactive/Fort.vue';
import Odak from './views/product/reactive/Odak.vue';
import Tuklab from './views/product/reactive/Tuklab.vue';
import Sclavo from './views/product/reactive/Sclavo.vue';
import Elisa from './views/product/reactive/Elisa.vue';
import Pcr from './views/product/reactive/Pcr.vue';
import Atom from './views/product/reactive/Atom.vue';
import Alcool from './views/product/chemical/Alcool.vue';
import Poly from './views/product/reactive/Poly.vue';
import ConsomablesComp from './views/product/consumable/ConsomablesComp.vue';
import Trust from './views/product/consumable/Trust.vue';
import Alto from './views/product/consumable/Alto.vue';
import Flmed from './views/product/consumable/Flmed.vue';
import ChimiquesComp from './views/product/chemical/ChimiquesComp.vue';
import ProductsPage from './views/admin/ProductsPage.vue';
// CLIENT / AUTH
import Connexion from './views/customer/Connexion.vue';
import Inscription from './views/customer/Inscription.vue';
import ForgotPassword from './views/customer/ForgotPassword.vue';
import Account from './views/customer/Account.vue';
import Adress from './views/customer/Adress.vue';
import CarnetAdresses from './views/customer/CarnetAdresses.vue';
import WishList from './views/customer/WishList.vue';

// CHECKOUT
import Shipping from './views/checkout/shipping.vue';
import Payment from './views/checkout/Payment.vue';
import sendConfirmation from './views/checkout/send-confirmation.vue';

// COMMANDES
import SidebarAdmin from './views/admin/SidebarAdmin.vue';
import OrderStatus from './views/admin/OrderStatus.vue';
import AdminOrders from './views/admin/AdminOrders.vue';
import DashboardAdmin from './views/admin/DashboardAdmin.vue';
import EditAccount from './views/customer/EditAccount.vue';
import ChangeMotPass from './views/customer/ChangeMotPass.vue';


// Helper d’auth (UNE seule vérité: sessionStorage)
const isLoggedIn = () => sessionStorage.getItem('isAuthenticated') === 'true';

const routes = [
  { path: '/', component: Home, name: 'Home' },
  { path: '/certification', component: Certification },
  { path: '/produits', component: Produits },
  { path: '/services', component: Services },
  { path: '/marques', component: Marques },
  { path: '/references', component: References },
  { path: '/contact', component: Contact },
  { path: '/shop', component: Shop, name: 'Shop' },
  { path: '/products', component: ProductsPage, name: 'products'},

  // Panier
  { path: '/panier', component: Panier, name: 'Panier' },

  // Détails produit
  {
    path: '/equipementLabo/:id',
    name: 'DetailsProduit',
    component: () => import('./views/product/equipment/DetailsProduit.vue'),
    props: true
  },

  // Produits divers
  { path: '/reactifs', component: Reactifs },
  { path: '/vitamines-mineraux', component: VitaminesMineraux },
  { path: '/topstar', component: Topstar },
  { path: '/equipementLabo', component: EquipementLabo },
  { path: '/fort', component: Fort },
  { path: '/odak', component: Odak },
  { path: '/tuklab', component: Tuklab },
  { path: '/sclavo', component: Sclavo },
  { path: '/elisa', component: Elisa },
  { path: '/pcr', component: Pcr },
  { path: '/atom', component: Atom },
  { path: '/alcool', component: Alcool },
  { path: '/poly', component: Poly },
  { path: '/consomablesComp', component: ConsomablesComp },
  { path: '/trust', component: Trust },
  { path: '/alto', component: Alto },
  { path: '/flmed', component: Flmed },
  { path: '/chimiquesComp', component: ChimiquesComp },

  // Auth / Client
  { path: '/connexion', component: Connexion, name: 'Connexion' },
  { path: '/inscription', component: Inscription, name: 'Inscription' },
  { path: '/forgot-password', component: ForgotPassword, name: 'ForgotPassword' },
  { path: '/edit-account', component: EditAccount, name: 'EditAccount' },
  { path: '/change-mot-passe', component: ChangeMotPass, name: 'ChangeMotPass' },

  // Pages nécessitant l’auth (meta.requiresAuth)
  { path: '/account', component: Account, name: 'Account', meta: { requiresAuth: true } },
  { path: '/adress', component: Adress, name: 'Adress', meta: { requiresAuth: true } },
  { path: '/carnetAdresses', component: CarnetAdresses, name: 'CarnetAdresses', meta: { requiresAuth: true } },
  { path: '/wishList', component: WishList, name: 'WichList', meta: { requiresAuth: true } },

  // Checkout
  { path: '/shipping', component: Shipping, name: 'Shipping', meta: { requiresAuth: true } },
  { path: '/payment', component: Payment, name: 'Payment', meta: { requiresAuth: true } },
  { path: '/send-confirmation', component: sendConfirmation, name: 'SendConfirmation', meta: { requiresAuth: true } },

  // Commandes
  { path: '/sidebarAdmin', component: SidebarAdmin, name: 'sidebarAdmin', meta: {requiresAuth: true}},
  { path: '/dashboardAdmin', component: DashboardAdmin, name: 'dashboardAdmin', meta: { requiresAuth: true } },
  { path: '/adminOrders', component: AdminOrders, name: 'AdminOrders', meta: { requiresAuth: true } },
  { path: '/orderStatus', component: OrderStatus, name: 'OrderStatus', meta: { requiresAuth: true } },
  {
    path: '/orderDetail/:id',
    name: 'OrderDetail',
    component: () => import('@/views/admin/OrderDetail.vue'),
    meta: { requiresAuth: true },
  },

  // 404 → home (optionnel)
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// Garde global d’auth (simple et fiable)
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(r => r.meta?.requiresAuth);
  const authed = isLoggedIn();

  if (requiresAuth && !authed) {
    // On mémorise la page voulue pour y retourner après login
    sessionStorage.setItem('redirectAfterLogin', to.fullPath);
    return next({ name: 'Connexion' });
  }
  next();
});

export default router;
